// import axios from "axios";
// import { useFormik } from "formik";
// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import * as Yup from "yup";
// import { base_url } from "../../../utils/AxiosConfig";

// let LeaveCatschema = Yup.object().shape({
//   CmpCode: Yup.string(),
//   name: Yup.string(),
//   icon: Yup.string(),
//   code: Yup.string(),
//   type: Yup.string(),
//   unit: Yup.string(),
//   validity_From: Yup.string(),
//   validity_To: Yup.string(),
//   effectiveAfter_Input: Yup.string(),
//   effectiveAfter_List: Yup.string(),
//   reset_List: Yup.string(),
//   carryForward_Input: Yup.string(),
//   carryForward_List: Yup.string(),
//   carryForward_Max: Yup.string(),
//   encashment_Input: Yup.string(),
//   encashment_List: Yup.string(),
//   encashment_Max: Yup.string(),
//   appl_Departments: Yup.string(),
//   appl_Designations: Yup.string(),
//   appl_Locations: Yup.string(),
//   appl_role: Yup.string(),
//   appl_Gender: Yup.string(),
//   appl_MaritalStatus: Yup.string(),
//   appl_EmployementType: Yup.string(),
// });
// const EditLeaveCatPopup = ({ LeaveCatName, handleClose }) => {

//   const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
//         let companyCode = null

//         if (storedUserDataArray) {
//           companyCode = storedUserDataArray[0].cmpcode
//         }

//   const [Data, setData] = useState();
//   const [LeaveCatData, setLeaveCatData] = useState();

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       CmpCode: companyCode,
//       name: LeaveCatData?.name || "",
//       icon: LeaveCatData?.icon || "-",
//       code: LeaveCatData?.name || "",
//       type: LeaveCatData?.type || "",
//       unit: LeaveCatData?.unit || "",
//       validity_From: LeaveCatData?.validity_From || "-",
//       validity_To: LeaveCatData?.validity_To || "-",
//       effectiveAfter_Input: LeaveCatData?.effectiveAfter_Input || "0",
//       effectiveAfter_List: LeaveCatData?.effectiveAfter_List || "",
//       reset_List: LeaveCatData?.reset_List || "-",
//       carryForward_Input: LeaveCatData?.carryForward_Input || "0",
//       carryForward_List: LeaveCatData?.carryForward_List || "-",
//       carryForward_Max: LeaveCatData?.carryForward_Max || "0",
//       encashment_Input: LeaveCatData?.encashment_Input || "0",
//       encashment_List: LeaveCatData?.encashment_List || "",
//       encashment_Max: LeaveCatData?.encashment_Max || "0",
//       appl_Departments: LeaveCatData?.appl_Departments || "-",
//       appl_Designations: LeaveCatData?.appl_Designations || "-",
//       appl_Locations: LeaveCatData?.appl_Locations || "-",
//       appl_role: LeaveCatData?.appl_role || "",
//       appl_Gender: LeaveCatData?.appl_Gender || "-",
//       appl_MaritalStatus: LeaveCatData?.appl_MaritalStatus || "-",
//       appl_EmployementType: LeaveCatData?.appl_EmployementType || "",

//     },
//     validationSchema: LeaveCatschema,

//     onSubmit: (values) => {
//       console.log(values);
//       setData([values]);
//     },
//   });

//   useEffect(() => {
//     const getLeaveCat = async () => {
//       const response = await axios.get(
//         `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/SINGLE/${LeaveCatName}`
//       );
//       console.log(response.data[0]);
//       if (response?.data) {
//         setLeaveCatData(response.data[0]);
//       } else {
//         console.log("error");
//       }
//     };

//     getLeaveCat();
//   }, [LeaveCatName]);

//   useEffect(() => {
//     const CreateLeave = async () => {

//       const postData = JSON.stringify(Data)

//       const response = await axios.post(
//         `${base_url}/api/PersonalInfoLeaveCategory`,postData, {
//           headers: {
//             'Content-Type': 'application/json',
//           }
//         }
//       );
//       if (response?.status===200) {
//         toast.success("Leave Category Edited Successfully")

//           // Close the modal by triggering the close button
//       document.querySelector('.btn-close').click();
//       } else {
//         console.log("error");
//         toast.error("Something went wrong")
//       }
//     };
// if(Data){
//   CreateLeave();
// }

//   }, [Data])

//   return (
//     <div>
//       <div
//         class="modal fade"
//         id="exampleModalsecond"
//         tabindex="-1"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div class="modal-dialog modal-xl">
//           <div class="modal-content">
//             <div class="modal-header">
//               <h1
//                 class="modal-title fs-small text-secondary "
//                 id="exampleModalLabel"
//               >
//                 Edit Leave Category
//               </h1>
//               <button
//                 type="button"
//                 class="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//                 onClick={() => handleClose()}
//               ></button>
//             </div>
//             <div class="modal-body">
//               <div className="container-fluid">
//                 <form onSubmit={formik.handleSubmit}>
//                   <div className="row">
//                     <div className="col-md-4">
//                       <div class="mb-3">
//                         <label for="name" className="form-label fs-small">
//                           Name
//                         </label>
//                         <input
//                           type="text"
//                           class="form-control"
//                           name="name"
//                           onChange={formik.handleChange("name")}
//                           onBlur={formik.handleBlur("name")}
//                           value={formik.values.name}
//                           // disabled

//                         />
//                       </div>

//                       <div class="mb-3">
//                         <label for="icon" className="form-label fs-small">
//                           Icon
//                         </label>
//                         <input
//                           type="text"
//                           class="form-control"
//                           name="icon"
//                           onChange={formik.handleChange("icon")}
//                           onBlur={formik.handleBlur("icon")}
//                           value={formik.values.icon}
//                         />
//                       </div>

//                       {/* <div class="mb-3">
//                         <label for="code" className="form-label fs-small">
//                           Code
//                         </label>
//                         <input
//                           type="text"
//                           class="form-control"
//                           name="code"
//                           onChange={formik.handleChange("code")}
//                           onBlur={formik.handleBlur("code")}
//                           value={formik.values.code}
//                           disabled
//                         />
//                       </div> */}

//                       <div class="mb-3">
//                         <label for="name" className="form-label fs-small">
//                           Type
//                         </label>
//                         <select
//                           class="form-select"
//                           aria-label="Default select example"
//                           name="type"
//                           onChange={formik.handleChange("type")}
//                           onBlur={formik.handleBlur("type")}
//                           value={formik.values.type}
//                         >
//                           <option  selected>{LeaveCatData?.type || "Select Type"}</option>
//                           <option value="1">Paid</option>
//                           <option value="2">Unpaid</option>
//                           <option value="3">On Duty</option>
//                           <option value="3">Restricted Holiday</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div className="col-md-4">
//                       <div class="mb-3">
//                         <label for="units" className="form-label fs-small">
//                           Units
//                         </label>
//                         <select
//                           class="form-select"
//                           name="unit"
//                           onChange={formik.handleChange("unit")}
//                           onBlur={formik.handleBlur("unit")}
//                           value={formik.values.unit}
//                         >
//                           <option selected>{LeaveCatData?.unit || "Units"}</option>
//                           <option value="1">Days</option>
//                         </select>
//                       </div>

//                       <div class="mb-3">
//                         <div className="row">
//                           <div className="col-6">
//                             <label for="code" className="form-label fs-small">
//                               From Date
//                             </label>
//                             <input
//                               type="text"
//                               class="form-control"
//                               name="validity_From"
//                               placeholder="Date"
//                               onFocus={(e) => (e.target.type = "date")}
//                               onChange={formik.handleChange("validity_From")}
//                               onBlur={formik.handleBlur("validity_From")}
//                               value={formik.values.validity_From}
//                             />
//                           </div>

//                           <div className="col-6">
//                             <label for="code" className="form-label fs-small">
//                               To Date
//                             </label>
//                             <input
//                               type="text"
//                               class="form-control"
//                               name="validity_To"
//                               placeholder="Date"
//                               onFocus={(e) => (e.target.type = "date")}
//                               onChange={formik.handleChange("validity_To")}
//                               onBlur={formik.handleBlur("validity_To")}
//                               value={formik.values.validity_To}
//                             />
//                           </div>
//                         </div>
//                       </div>

//                       <div class="mb-3">
//                         <label for="code" className="form-label fs-small">
//                           Effective After
//                         </label>
//                         <input
//                           type="text"
//                           class="form-control"
//                           name="effectiveAfter_Input"
//                           placeholder="Date"
//                           onFocus={(e) => (e.target.type = "date")}
//                           onChange={formik.handleChange("effectiveAfter_Input")}
//                           onBlur={formik.handleBlur("effectiveAfter_Input")}
//                           value={formik.values.effectiveAfter_Input}
//                         />
//                       </div>

//                       <div class="mb-3">
//                         <label for="code" className="form-label fs-small">
//                           Reset
//                         </label>
//                         <select
//                           class="form-select"
//                           name="reset_List"
//                           onChange={formik.handleChange("reset_List")}
//                           onBlur={formik.handleBlur("reset_List")}
//                           value={formik.values.reset_List}
//                         >
//                           <option selected>Select Type</option>
//                           <option value="1">yearly</option>
//                           <option value="1">monthly</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div className="col-md-4">
//                       <div class="mb-3">
//                         <label for="units" className="form-label fs-small">
//                           Carry forward
//                         </label>
//                         <input
//                           type="text"
//                           class="form-control"
//                           name="carryForward_Input"
//                           onChange={formik.handleChange("carryForward_Input")}
//                           onBlur={formik.handleBlur("carryForward_Input")}
//                           value={formik.values.carryForward_Input}
//                         />
//                       </div>

//                       <div class="mb-3">
//                         <label for="code" className="form-label fs-small">
//                           Encachement
//                         </label>
//                         <input
//                           type="text"
//                           class="form-control"
//                           name="encashment_Input"
//                           onChange={formik.handleChange("encashment_Input")}
//                           onBlur={formik.handleBlur("encashment_Input")}
//                           value={formik.values.encashment_Input}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   <div className="row">
//                     <p className="fs-small text-secondary mt-2">
//                       Applicable to
//                     </p>
//                     <div className="col-md-4">
//                       <div class="mb-3">
//                         <label for="name" className="form-label fs-small">
//                           Departments
//                         </label>
//                         <select
//                           class="form-select"
//                           name="appl_Departments"
//                           onChange={formik.handleChange("appl_Departments")}
//                           onBlur={formik.handleBlur("appl_Departments")}
//                           value={formik.values.appl_Departments}
//                         >
//                           <option value={LeaveCatData?.appl_Departments || "Select Department"} selected>{LeaveCatData?.appl_Departments || "Select Department"}</option>
//                           <option value="1">yearly</option>
//                           <option value="1">monthly</option>
//                         </select>
//                       </div>

//                       <div class="mb-3">
//                         <label for="name" className="form-label fs-small">
//                           Designations
//                         </label>
//                         <select
//                           class="form-select"
//                           name="appl_Designations"
//                           onChange={formik.handleChange("appl_Designations")}
//                           onBlur={formik.handleBlur("appl_Designations")}
//                           value={formik.values.appl_Designations}
//                         >
//                           <option value={LeaveCatData?.appl_Designations || "Select Department"} selected>{LeaveCatData?.appl_Designations || "Select Department"}</option>
//                           <option value="1">yearly</option>
//                           <option value="1">monthly</option>
//                         </select>
//                       </div>

//                       <div class="mb-3">
//                         <label for="name" className="form-label fs-small">
//                           Locations
//                         </label>
//                         <select
//                           class="form-select"
//                           name="appl_Locations"
//                           onChange={formik.handleChange("appl_Locations")}
//                           onBlur={formik.handleBlur("appl_Locations")}
//                           value={formik.values.appl_Locations}
//                         >
//                           <option selected>{LeaveCatData?.appl_Designations || "appl_Locations"}</option>
//                           <option value="1">yearly</option>
//                           <option value="1">monthly</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div className="col-md-4">
//                       <div class="mb-3">
//                         <label for="name" className="form-label fs-small">
//                           Role
//                         </label>
//                         <select
//                           class="form-select"
//                           name="appl_role"
//                           onChange={formik.handleChange("appl_role")}
//                           onBlur={formik.handleBlur("appl_role")}
//                           value={formik.values.appl_role}
//                         >
//                           <option value={LeaveCatData?.appl_Designations || "Select Role"} selected>{LeaveCatData?.appl_Designations || "Select Role"}</option>
//                           <option value="yearly">yearly</option>
//                           <option value="monthly">monthly</option>
//                         </select>
//                       </div>

//                       <div class="mb-3">
//                         <label for="name" className="form-label fs-small">
//                           Gender
//                         </label>
//                         <select
//                           class="form-select"
//                           name="appl_Gender"
//                           onChange={formik.handleChange("appl_Gender")}
//                           onBlur={formik.handleBlur("appl_Gender")}
//                           value={formik.values.appl_Gender}
//                         >
//                           <option value={LeaveCatData?.appl_Gender || "Select Role"} selected>{LeaveCatData?.appl_Gender || "Select Role"}</option>
//                           <option value="Male">Male</option>
//                           <option value="Female">Female</option>
//                           <option value="Others">Others</option>
//                         </select>
//                       </div>

//                       <div class="mb-3">
//                         <label for="name" className="form-label fs-small">
//                           Marital Status
//                         </label>
//                         <select
//                           class="form-select"
//                           name="appl_MaritalStatus"
//                           onChange={formik.handleChange("appl_MaritalStatus")}
//                           onBlur={formik.handleBlur("appl_MaritalStatus")}
//                           value={formik.values.appl_MaritalStatus}
//                         >
//                           <option value={LeaveCatData?.appl_MaritalStatus || "Select Status"} selected>{LeaveCatData?.appl_MaritalStatus || "Select Status"}</option>
//                           <option value="Single">Single</option>
//                           <option value="Married">Married</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div className="col-md-4">
//                       <div class="mb-3">
//                         <label for="name" className="form-label fs-small">
//                           Employment type
//                         </label>
//                         <select
//                           class="form-select"
//                           name="appl_EmployementType"
//                           onChange={formik.handleChange("appl_EmployementType")}
//                           onBlur={formik.handleBlur("appl_EmployementType")}
//                           value={formik.values.appl_EmployementType}
//                         >
//                           <option value={LeaveCatData?.appl_EmployementType|| "Select EmpType"} selected>{LeaveCatData?.appl_EmployementType || "Select EmpType"}</option>
//                           <option value="Permanent">Permanent</option>
//                           <option value="on Contract">on Contract</option>
//                           <option value="Temporary">Temporary</option>
//                           <option value="Trainee">Trainee</option>
//                         </select>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="text-end">
//                     <button type="submit" class="btn dash-btn">
//                       Save
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//             <div class="modal-footer"></div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditLeaveCatPopup;

import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { base_url } from "../../../utils/AxiosConfig";

const LeaveCatSchema = Yup.object().shape({
  // name: Yup.string().required("Name is required"),
  name: Yup.string(),
  icon: Yup.string(),
  code: Yup.string(),
  // type: Yup.string().required("Type is required"),
  type: Yup.string(),
  // unit: Yup.string().required("Unit is required"),
  unit: Yup.string(),
  validity_From: Yup.string(),
  validity_To: Yup.string(),
  effectiveAfter_Input: Yup.string(),
  effectiveAfter_List: Yup.string(),
  reset_List: Yup.string(),
  carryForward_Input: Yup.string(),
  carryForward_List: Yup.string(),
  carryForward_Max: Yup.string(),
  encashment_Input: Yup.string(),
  encashment_List: Yup.string(),
  encashment_Max: Yup.string(),
  appl_Departments: Yup.string(),
  appl_Designations: Yup.string(),
  appl_Locations: Yup.string(),
  appl_role: Yup.string(),
  appl_Gender: Yup.string(),
  appl_MaritalStatus: Yup.string(),
  appl_EmployementType: Yup.string(),
});

const EditLeaveCatPopup = ({ LeaveCatName, handleClose }) => {
  console.log("LeaveCatName1:", LeaveCatName);

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray?.[0]?.cmpcode || "";

  const [leaveCatData, setLeaveCatData] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      name: leaveCatData?.name || "",
      icon: leaveCatData?.icon || "-",
      code: leaveCatData?.code || "",
      type: leaveCatData?.type || "",
      unit: leaveCatData?.unit || "",
      // validity_From: leaveCatData?.validity_From || "",
      // validity_To: leaveCatData?.validity_To || "",
            validity_From: "1900-01-01",
      validity_To: "1900-01-01",
      effectiveAfter_Input: leaveCatData?.effectiveAfter_Input || "0",
      effectiveAfter_List: leaveCatData?.effectiveAfter_List || "",
      reset_List: leaveCatData?.reset_List || "-",
      carryForward_Input: leaveCatData?.carryForward_Input || "0",
      carryForward_List: leaveCatData?.carryForward_List || "-",
      carryForward_Max: leaveCatData?.carryForward_Max || "0",
      encashment_Input: leaveCatData?.encashment_Input || "0",
      encashment_List: leaveCatData?.encashment_List || "",
      encashment_Max: leaveCatData?.encashment_Max || "0",
      appl_Departments: leaveCatData?.appl_Departments || "-",
      appl_Designations: leaveCatData?.appl_Designations || "-",
      appl_Locations: leaveCatData?.appl_Locations || "-",
      appl_role: leaveCatData?.appl_role || "",
      appl_Gender: leaveCatData?.appl_Gender || "-",
      appl_MaritalStatus: leaveCatData?.appl_MaritalStatus || "-",
      appl_EmployementType: leaveCatData?.appl_EmployementType || "",
    },
    validationSchema: LeaveCatSchema,
    onSubmit: async (values) => {
      try {
        setSubmitting(true);
        // const response = await axios.post(
        //   `${base_url}/api/PersonalInfoLeaveCategory`,
        //   JSON.stringify(values),
        //   {
        //     headers: { "Content-Type": "application/json" },
        //   },
        // );
        const response = await axios.post(
          `${base_url}/api/PersonalInfoLeaveCategory`,
          [values],
          {
            headers: { "Content-Type": "application/json" },
          },
        );

        if (response.status === 200) {
          toast.success("Leave Category updated successfully");
          handleClose();
        } else {
          toast.error("Failed to update leave category");
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const fetchLeaveCat = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/SINGLE/${LeaveCatName}`,
      );
      if (res.data?.[0]) {
        setLeaveCatData(res.data[0]);
      }
    } catch (err) {
      console.error("Failed to load leave category", err);
      toast.error("Could not load category data");
    }
  };

  useEffect(() => {
    if (!LeaveCatName) return;
    console.log("LeaveCatName2:", LeaveCatName);

    fetchLeaveCat();
  }, [LeaveCatName]);

  // if (!leaveCatData) {
  //   return (
  //     <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
  //       <div className="bg-white p-8 rounded-xl shadow-xl">
  //         Data Not available!...
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      {/* Header */}
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[72vh] overflow-y-auto scrollbar-none">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-[#2663EB]">
          <h2 className="text-xl font-semibold text-white">
            Edit Leave Category
          </h2>
          <button
            onClick={handleClose}
            className="text-white hover:text-gray-800 text-3xl font-bold"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <form onSubmit={formik.handleSubmit} className="space-y-8">
            {/* Main Fields - 3 columns */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Column 1 */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    // onChange={formik.handleChange}
                     onChange={(e) => {
                    const value = e.target.value;

                    formik.setFieldValue("name", value);
                    formik.setFieldValue("code", value);
                  }}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none ${
                      formik.touched.name && formik.errors.name
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <p className="mt-1 text-sm text-red-600">
                      {formik.errors.name}
                    </p>
                  )}
                </div>

                {/* <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Icon
                  </label>
                  <input
                    type="text"
                    name="icon"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.icon}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  />
                </div> */}

                <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Gender
                  </label>
                  <select
                    name="appl_Gender"
                    onChange={formik.handleChange}
                    value={formik.values.appl_Gender}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  >
                    <option value="-">All</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Others">Others</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Type
                  </label>
                  <select
                    name="type"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.type}
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none ${
                      formik.touched.type && formik.errors.type
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  >
                    <option value="">Select Type</option>
                    <option value="Paid">Paid</option>
                    <option value="Unpaid">Unpaid</option>
                    <option value="On Duty">On Duty</option>
                    <option value="Restricted Holiday">Restricted Holiday</option>
                  </select>
                  {formik.touched.type && formik.errors.type && (
                    <p className="mt-1 text-sm text-red-600">
                      {formik.errors.type}
                    </p>
                  )}
                </div>
              </div>

              {/* Column 2 */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Units
                  </label>
                  <select
                    name="unit"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.unit}
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none ${
                      formik.touched.unit && formik.errors.unit
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  >
                    <option value="">Select Unit</option>
                    <option value="Days">Days</option>
                    {/* Add more options if needed */}
                  </select>
                </div>

                {/* <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Validity Period
                  </label>
                  <div className="grid grid-cols-2 gap-3">
                    <input
                      type="date"
                      name="validity_From"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.validity_From}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    />
                    <input
                      type="date"
                      name="validity_To"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.validity_To}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    />
                  </div>
                </div> */}

                {/* <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Effective After
                  </label>
                  <input
                    type="date"
                    name="effectiveAfter_Input"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.effectiveAfter_Input}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  />
                </div> */}

                <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Effective After
                  </label>
                  <input
                    // type="date"
                    type="number"
                    name="effectiveAfter_Input"
                    onChange={formik.handleChange("effectiveAfter_Input")}
                    value={formik.values.effectiveAfter_Input}
                    className="w-full border rounded-lg px-3 py-2 mt-1"
                  />
                </div>

                <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Reset
                  </label>
                  <select
                    name="reset_List"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.reset_List}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  >
                    <option value="-">Select Reset</option>
                    <option value="Yearly">Yearly</option>
                    <option value="Monthly">Monthly</option>
                  </select>
                </div>
              </div>

              {/* Column 3 */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Carry Forward
                  </label>
                  <input
                    type="number"
                    name="carryForward_Input"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.carryForward_Input}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  />
                </div>

                <div>
                  <label className="block text-sm   text-gray-700 mb-1">
                    Encashment
                  </label>
                  <input
                    type="number"
                    name="encashment_Input"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.encashment_Input}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  />
                </div>
              </div>
            </div>

            {/* Applicable To Section */}
            {/* <div className="pt-6 border-t border-gray-200">
              <h3 className="text-lg   text-gray-800 mb-4">
                Applicable To
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Departments, Designations, Locations 
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm   text-gray-700 mb-1">
                      Departments
                    </label>
                    <select
                      name="appl_Departments"
                      onChange={formik.handleChange}
                      value={formik.values.appl_Departments}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    >
                      <option value="-">All Departments</option>
                      {/* Replace with real options / multi-select if needed 
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm   text-gray-700 mb-1">
                      Designations
                    </label>
                    <select
                      name="appl_Designations"
                      onChange={formik.handleChange}
                      value={formik.values.appl_Designations}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    >
                      <option value="-">All Designations</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm   text-gray-700 mb-1">
                      Locations
                    </label>
                    <select
                      name="appl_Locations"
                      onChange={formik.handleChange}
                      value={formik.values.appl_Locations}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    >
                      <option value="-">All Locations</option>
                    </select>
                  </div>
                </div>

                {/* Role, Gender, Marital Status 
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm   text-gray-700 mb-1">
                      Role
                    </label>
                    <select
                      name="appl_role"
                      onChange={formik.handleChange}
                      value={formik.values.appl_role}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    >
                      <option value="">Select Role</option>
                      {/* Add real roles 
                    </select>
                  </div>

                  

                  <div>
                    <label className="block text-sm   text-gray-700 mb-1">
                      Marital Status
                    </label>
                    <select
                      name="appl_MaritalStatus"
                      onChange={formik.handleChange}
                      value={formik.values.appl_MaritalStatus}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    >
                      <option value="-">All</option>
                      <option value="Single">Single</option>
                      <option value="Married">Married</option>
                    </select>
                  </div>
                </div>

                {/* Employment Type 
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm   text-gray-700 mb-1">
                      Employment Type
                    </label>
                    <select
                      name="appl_EmployementType"
                      onChange={formik.handleChange}
                      value={formik.values.appl_EmployementType}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    >
                      <option value="">Select Type</option>
                      <option value="Permanent">Permanent</option>
                      <option value="on Contract">On Contract</option>
                      <option value="Temporary">Temporary</option>
                      <option value="Trainee">Trainee</option>
                    </select>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="flex justify-center items-center pt-6 ">
              {/* <button
                type="button"
                onClick={handleClose}
                className="px-6 py-2.5 mr-3 bg-gray-200 hover:bg-gray-300 text-gray-800   rounded-lg transition"
              >
                Cancel
              </button>  */}

              <button
                type="submit"
                disabled={submitting || !formik.isValid}
                className={`px-8 py-2.5 font-semibold rounded-lg text-white transition ${
                  submitting || !formik.isValid
                    ? "bg-blue-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700 shadow-sm"
                }`}
              >
                {submitting ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditLeaveCatPopup;
